module.exports = __webpack_public_path__ + "img/view-more.76362a3e.png";